import React from "react"
import PropTypes from "prop-types"
import I18n from "lib/i18n"
import { CircleUserRound } from "lucide-react"
import { menuLinkStyle } from "../AccountMenu/shared"
import ActionIcon from "../ActionIcon"
import clsx from "classnames"
import DashboardLink from "../AccountMenu/DashboardLink"

const returnToPath = () => {
  if (window && window.location) {
    return `?return_to=${window.location.pathname}`
  }

  return ""
}

const UnauthenticatedActions = () => (
  <div className="flex h-full">
    <a
      className={clsx(
        menuLinkStyle,
        "hidden border-0 border-r border-solid border-gray-200 md:inline-flex",
      )}
      href="/become-an-author"
    >
      {I18n.t("top_bar.label.author_sign_up")}
    </a>
    <a
      className={clsx(
        menuLinkStyle,
        "hidden border-0 border-r border-solid border-gray-200 md:inline-flex",
      )}
      href={`/sign_up${returnToPath()}`}
    >
      {I18n.t("top_bar.label.reader_sign_up")}
    </a>
    <a
      className={clsx(
        menuLinkStyle,
        "border-0 border-solid border-gray-200 max-sm:!px-2 max-sm:!py-0 lg:border-r",
      )}
      href={`/sign_in${returnToPath()}`}
    >
      <CircleUserRound className="size-6 md:hidden" aria-label={I18n.t("top_bar.label.sign_in")} />
      <span className="hidden md:inline-flex">{I18n.t("top_bar.label.sign_in")}</span>
    </a>
  </div>
)

const TopbarAdminShortcuts = ({ adminActions }) => {
  const firstAction = adminActions[0]

  if (!firstAction) {
    return null
  }

  return (
    <div data-testid="admin-shortcuts" className="flex h-full">
      <a
        href={firstAction.path}
        className={clsx(
          menuLinkStyle,
          "hidden border-0 border-r border-solid border-gray-200 md:inline-flex",
        )}
      >
        {firstAction.icon ? <ActionIcon small name={firstAction.icon} /> : null}
        {firstAction.label}
      </a>
    </div>
  )
}

const TopbarViewerActions = ({ adminActions, user = undefined, role }) => {
  if (user) {
    return (
      <React.Fragment>
        <div className="hidden h-full border-0 border-r border-solid border-gray-200 md:inline-flex">
          <DashboardLink user={user} userRole={role} />
        </div>
        <TopbarAdminShortcuts adminActions={adminActions} />
      </React.Fragment>
    )
  }

  return <UnauthenticatedActions />
}

TopbarViewerActions.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  role: PropTypes.string,
  adminActions: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.string,
    }),
  ),
}

TopbarAdminShortcuts.propTypes = {
  adminActions: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.string,
    }),
  ).isRequired,
}

export default TopbarViewerActions
